(function ($) {

    jQuery(document).ready(function () {

        // ReGuest
        borgobrufa_reguest_form();

    });


    /////////////// ==== ReGuest Start ==== ///////////////

    window.validEmail = window.validEmail || function (v) {
        var r = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?");
        return (v.match(r) == null) ? false : true;
    };

    window.reguest_form_add_room = window.reguest_form_add_room || function (index) {
        // vars
        var room_box = jQuery('#rooms_box');
        var template = $('#rooms_template').text();
        var html;
        var index = parseInt(index, 10);
        var data = {};
        data.room = {};
        data.room.id = index;
        // mustache
        html = Mustache.render(template, data);
        room_box.append(html);
        // adding children ages
        // var sel_children = room_box.find('.room_children .room_children_n');
        // sel_children.on('change','select',function(){
        //     // vars
        //     var val = $(this).val();
        //     var child_box = $(this).closest('.room_children').find('.room_children_ages');
        //     reguest_form_add_children_age(child_box,val);
        // });
        // remove room_box
        var remove_room = room_box.find('.remove_room');
        remove_room.on('click', function () {
            // vars
            var box = $(this).closest('.room_box');
            box.remove();
        });
    };

// window.reguest_form_add_children_age = window.reguest_form_add_children_age || function(div,index){
//     // check // div is the div in which i want to add the child box , index is the n of children selected
//     if (typeof div === 'undefined' || typeof index === 'undefined' || div.length === 0)  return false;
//     // vars
//     var template = $('#children_age_template').text();
//     index = parseInt(index,10);
//     var html;
//     var i;
//     var t;
//     var actual;
//     var nstart;
//     var data = {};
//     var room_id = div.closest('.room_box').data('id');
//     // check if the sel children value is different than actual children age boxes
//     var children_box = div.find('.children_box');
//     // if i select different
//     if(children_box.length!==index) {
//         // comparing
//         if(children_box.length<index) {
//             // if i select more
//             // current boxes
//             actual = children_box.length;
//             nstart = parseInt(actual+1,10);
//             // cycle from actual +1 to index
//             for(i=nstart;i<=index;i++) {
//                 //
//                 data.children = {};
//                 data.children.id = i;
//                 data.children.roomid = room_id;
//                 // mustache
//                 html = Mustache.render(template, data);
//                 //
//                 div.append(html);
//             }
//         } else {
//             // if i select less
//             // current boxes
//             actual = children_box.length;
//             nstart = parseInt(index+1,10);
//             // cycle of difference from the selected to actual
//             for(t=nstart;t<=actual;t++) {
//                 div.find('[data-id='+t+']').remove();
//             }
//         }
//
//     }
//
// };

// reguest_form validation
    window.form_box_validation = window.form_box_validation || function (form) {
        if (typeof form === 'undefined' || form.length === 0) return false;
        // vars
        var fields_box = form.find('.required:not(.hidden)');
        var error = {};
        error.type = [];
        //
        fields_box.each(function () {
            var box = jQuery(this);
            if (box.hasClass('privacy')) {
                if (!box.find('input').is(':checked')) {
                    error.type.push('privacy_check');
                    box.addClass('error');
                } else {
                    box.removeClass('error');
                }
            } else {
                var data_to_check = box.find('input,select');
                if (data_to_check.val() === '') {
                    box.addClass('error');
                    error.type.push('missing_fields');
                } else {
                    box.removeClass('error');
                }
                // email check
                if (data_to_check.attr('name') === 'EmailAddress') {
                    if (data_to_check.val() !== '') {
                        if (!validEmail(data_to_check.val())) {
                            box.addClass('error');
                            error.type.push('wrong_email');
                        }
                    }
                }
            }


        });
        // go error or not
        error.error = (form.find('.error').length > 0);
        // spam check
        var spmck = form.find('input[name=contact_form_spmck]');
        if (spmck.is(':checked')) {
            jQuery(this).addClass('error');
            error.type.push('spam');
            error.error = true;
        }
        // return
        return error;
    };

// reguest_form
    window.borgobrufa_reguest_form = window.borgobrufa_reguest_form || function () {
        // vars
        var form_box = $('.reguest_form_box');
        var form = form_box.find('form');
        // var fields = form_box.find('.field');
        // setting first room
        reguest_form_add_room(1);
        jQuery('input[name=rooms_n]').val(1);
        // adding rooms
        var add_room = form_box.find('#add_room');
        add_room.on('click', function () {
            var room_boxes = jQuery('#rooms_box .room_box');
            var index = room_boxes.length + 1;
            jQuery('input[name=rooms_n]').val(index);
            reguest_form_add_room(index);
        });
        // // gender field
        // var sel_gender = form_box.find('.field.title');
        // var gender_array_setting = {
        //     'mr': {
        //         'Gender': 1,
        //         'GuestUserType': 0
        //     },
        //     'miss': {
        //         'Gender': 2,
        //         'GuestUserType': 0
        //     },
        //     'mrs': {
        //         'Gender': 2,
        //         'GuestUserType': 0
        //     },
        //     'company': {
        //         'Gender': 0,
        //         'GuestUserType': 1
        //     },
        //     'family': {
        //         'Gender': 0,
        //         'GuestUserType': 2
        //     }
        // };
        // sel_gender.on('change', 'select', function () {
        //     // vars
        //     var val = $(this).val();
        //     if (val !== '' && typeof gender_array_setting[val] !== 'undefined') {
        //         form_box.find('input[name=Gender]').val(gender_array_setting[val]['Gender']);
        //         form_box.find('input[name=GuestUserType]').val(gender_array_setting[val]['GuestUserType']);
        //         // manage name fields
        //         if (val === 'company') {
        //             // hide
        //             form_box.find('.field.name').addClass('hidden');
        //             // show
        //             form_box.find('.field.company_name').removeClass('hidden');
        //         }
        //         if (val === 'family') {
        //             // hide
        //             form_box.find('.field.name').addClass('hidden');
        //             // show
        //             form_box.find('.field.family_name').removeClass('hidden');
        //         }
        //         if (val === 'mr' || val === 'mrs' || val === 'miss') {
        //             // hide
        //             form_box.find('.field.name').addClass('hidden');
        //             // show
        //             form_box.find('.field.first_name').removeClass('hidden');
        //             form_box.find('.field.last_name').removeClass('hidden');
        //         }
        //     }
        // });
        // datepickerz
        // vars
        var today = new Date();
        var tomorrow = new Date(today.getTime() + 86400000);
        var arrival_dp = $('input#ArrivalDate');
        var departure_dp = $('input#DepartureDate');
        // init the datepickers
        arrival_dp.datepicker({
            'minDate': today,
            'duration': 'fast',
            dateFormat: 'dd-mm-yy',
            onClose: function (selectedDate) {
                //
                var arrival_date = arrival_dp.datepicker('getDate');
                var departure_date = departure_dp.datepicker('getDate');
                var new_departure_date;
                // if refreshed the page i click on arrival and then on departure without selecting date, i throw an error, to avoid this i have to check arrivaldate
                if (arrival_date === null) {
                    arrival_dp.datepicker('setDate', today);
                    arrival_date = today;
                }
                new_departure_date = new Date(arrival_date.getTime() + 86400000);
                // checking if the date of the departure is before the new selected arrival date and i put a min date on departure
                departure_dp.datepicker('option', 'minDate', new_departure_date);
                if (departure_date <= arrival_date) {
                    departure_dp.datepicker('setDate', new_departure_date);
                }
                // go to the other datepicker
                departure_dp.datepicker("show");
            }
        }).datepicker('setDate', today);
        // datepicker
        departure_dp.datepicker({
            'minDate': '+1d',
            'duration': 'fast',
            dateFormat: 'dd-mm-yy',
            onClose: function (selectedDate) {

            }
        }).datepicker("setDate", tomorrow);
        // ajax on submit
        form.submit(function (e) {
            e.preventDefault();
            var validation = form_box_validation(form);
            //
            if (validation.error === true) {
                var error_msg = '';
                // window.error_msg_missing_fields
                if (jQuery.inArray('spam', validation.type) !== -1) {
                    error_msg = error_msg + '<span>Spam</span>';
                }
                if (jQuery.inArray('missing_fields', validation.type) !== -1) {
                    error_msg = error_msg + '<span>' + window.error_msg_missing_fields + '</span>';
                }
                if (jQuery.inArray('wrong_email', validation.type) !== -1) {
                    error_msg = error_msg + '<span>' + window.wrong_email_sentence + '</span>';
                }
                if (jQuery.inArray('privacy_check', validation.type) !== -1) {
                    error_msg = error_msg + '<span>' + window.privacy_accept_sentence + '</span>';
                }
                // put html inside box
                var error_html = '<div class="msg error_msg">' + error_msg + '</div>';
                form.find('.msg_box').html(error_html);
                // scroll_to(jQuery('#reguest_form_box'));
                return false;
            } else {
                form.find('.msg_box').html('');
            }
            form_box.addClass('sending');
            var data = {'action': $(this).attr('action'), 'form': form.serializeArray()};
            form.find(":input").attr("disabled", true);
            $.ajax({
                url: ajax_obj.ajax_url,
                // action: $(this).attr('action'),
                // action: 'reGuest_send_request',
                data: data,
                dataType: 'json',
                type: 'POST',
                success: function (response) {
                    //
                    if (response.Success !== true) {
                        // error
                        form.find('.msg_box').html('<div class="msg error_msg">' + window.error_msg + '</div>');
                        form_box.removeClass('sending');
                        form.find(":input").attr("disabled", false);
                    } else {
                        // success
                        //// setTimeout(function() { window.location.reload(); }, 500);
                        // manipulate form
                        form_box.removeClass('sending');
                        form.find(":input").attr("disabled", false);
                        form_box.find('.fields').addClass('hide');
                        // showing sentences
                        form.find('.msg_box').html('<div class="msg confirmation_msg">' + window.confirmation_msg + '</div>');
                        setTimeout(function () {
                            $("html,body").animate({scrollTop: 0}, 1000);
                        }, 200)
                    }
                }
            });
        });
    };

/////////////// ==== ReGuest End ==== ///////////////

})(jQuery);
